import React from 'react'

import PropTypes from "prop-types"
import {Box, Skeleton} from "@mui/material"
import {GridOverlay} from "@mui/x-data-grid"

const ROW_COUNT_DEFAULT = 10

const CustomLoadingOverlay = ({columns}) => {
    const items = columns.slice(0, -1)

    return (
        <GridOverlay
            sx={{
                background: "transparent",
                minHeight: "400px",
                display: "flex",
                alignItems: "flex-start",
            }}
        >
            <Box sx={{width: "100%"}}>
                {Array.from({length: ROW_COUNT_DEFAULT}).map((_, rowIndex) => (
                    <Box
                        key={rowIndex}
                        sx={{
                            height: "56px",
                            display: "flex",
                            mb: 1,
                            backgroundColor:
                                rowIndex % 2 === 0
                                    ? "rgba(255, 255, 255, 0.03)"
                                    : "#272D42",
                            alignItems: "center",
                        }}
                    >
                        {items.map((col, colIndex) => (
                            <Box
                                key={col.field || colIndex}
                                sx={{
                                    p: 2,
                                    flex: col.flex || 1,
                                    minWidth: 0,
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "flex-start",
                                    pr: 2,
                                }}
                            >
                                <Skeleton
                                    variant="rectangular"
                                    animation="wave"
                                    sx={{
                                        width: "90%",
                                        height: 14,
                                        backgroundColor: "rgba(255, 255, 255, 0.1)",
                                        "&::after": {
                                            background: "linear-gradient(90deg, rgba(255,255,255,0) 0%, rgba(255,255,255,0.4) 50%, rgba(255,255,255,0) 100%)",
                                        },
                                    }}
                                />
                            </Box>
                        ))}
                    </Box>
                ))}
            </Box>
        </GridOverlay>
    )
}
CustomLoadingOverlay.propTypes = {
    columns: PropTypes.arrayOf(
        PropTypes.shape({
            field: PropTypes.string.isRequired,
        })
    ).isRequired,
}

export default CustomLoadingOverlay